var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
function isInViewport(element) {
    var rect = element.getBoundingClientRect();
    return (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth));
}
var LazyLoadImage = /** @class */ (function (_super) {
    __extends(LazyLoadImage, _super);
    function LazyLoadImage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.start = false;
        return _this;
    }
    LazyLoadImage.prototype.created = function () {
        window.addEventListener("scroll", this.onScroll);
    };
    LazyLoadImage.prototype.destroyed = function () {
        window.removeEventListener("scroll", this.onScroll);
    };
    LazyLoadImage.prototype.onScroll = function () {
        this.start = true;
    };
    LazyLoadImage.prototype.mounted = function () {
        if (this.$refs.component) {
            if (isInViewport(this.$refs.component)) {
                this.start = true;
            }
        }
        else {
            this.start = true;
        }
    };
    LazyLoadImage.prototype.getBackgroundImage = function () {
        if (this.start) {
            return {
                backgroundImage: 'url("' + this.image + '")'
            };
        }
        return {};
    };
    __decorate([
        Prop()
    ], LazyLoadImage.prototype, "image", void 0);
    LazyLoadImage = __decorate([
        Component({
            components: {},
        })
    ], LazyLoadImage);
    return LazyLoadImage;
}(Vue));
export default LazyLoadImage;
